var render = function render(){var _vm=this,_c=_vm._self._c;return _c('geko-base-crud',{key:'task-list' + _vm.componentKey,attrs:{"config":_vm.config},scopedSlots:_vm._u([{key:"list-before-create",fn:function(){return [(_vm.$_sys.isAllowed('task-create'))?_c('v-btn',{attrs:{"variant":"info"},on:{"click":function($event){return _vm.onGenerate()}}},[_vm._v("Generate Task")]):_vm._e()]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }